document.addEventListener('DOMContentLoaded', function () {
  console.log('Product Custom JS executed');
  const productTitle = document.querySelector('.product__info-wrapper h1.product__title');
  const productPrice = document.querySelector('.product__info-wrapper .price-wrapper');
  const productInfoContainer = document.querySelector('.product__info-container');
  const variantSelector = document.querySelector('variant-radios');
  const addToCartButton = document.querySelector('.product-form__buttons button[name="add"]');
  const fixedCTA = document.getElementById('fixed-cta');
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  
  console.log(addToCartButton);

  function switchProductInfoContainer(bool) {
    if (bool) {
      productInfoContainer.style.position = 'relative';
    } else {
      productInfoContainer.style.position = '';
    }
  }

  function showFixedCTA() {
    const price = productPrice.querySelector('.price dl');
    switchProductInfoContainer(true);
    fixedCTA.style.display = 'flex';
    productTitle.classList.add('product-title--fixed');
    price.classList.add('product-price--fixed');
    variantSelector.classList.add('variant-selector--fixed');
    addToCartButton.classList.remove('button--secondary');
    addToCartButton.classList.add('button--primary');
    addToCartButton.classList.add('add-to-cart-button--fixed');
  }

  function hideFixedCTA() {
    const price = productPrice.querySelector('.price dl');
    switchProductInfoContainer(false);
    fixedCTA.style.display = 'none';
    productTitle.classList.remove('product-title--fixed');
    price.classList.remove('product-price--fixed');
    variantSelector.classList.remove('variant-selector--fixed');
    addToCartButton.classList.add('button--secondary');
    addToCartButton.classList.remove('button--primary');
    addToCartButton.classList.remove('add-to-cart-button--fixed');
  }

  // scroll control
  function handleScroll() {
    const YAxis = window.scrollY;
    if (YAxis > screenHeight && screenWidth >= 768) { // Desktop
      showFixedCTA();
    } else if (YAxis > screenHeight * 2 - 100) { // Mobile
      showFixedCTA();
    } else {
      hideFixedCTA();
    }
  }

  window.addEventListener('scroll', handleScroll);
});
